import React from 'react';

function KidsSettings() {
    return (
        <div className='my-3'>
            
        </div>
    );
}

export default KidsSettings;
